import styled from "styled-components";

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    min-height: 100px;
    margin: 30px;
`;